import { TransactionStatus } from './types';

export const statusStyles: Record<TransactionStatus, string> = {
  new: 'bg-warning',
  paid: 'bg-success',
  confirmed: 'bg-success',
  completed: 'bg-success',
  expired: 'bg-warning',
  invalid: 'bg-destruction',
};
